import amplitudeEventTracker from 'src/analitycs/index';
import dayjs from 'dayjs';
import { filterProp } from '@interfaces/transactionsFilters';


export const PORTAL_OPENED = 'Portal Opened';
export const TRANSACTION_DETAIL_TAPPED = 'Transaction Detail Tapped';
export const FILTER_TRANSACTIONS_PORTAL_TAPPED = 'Filter Transactions Portal Tapped';
export const SECTION_PORTAL_TAPPED = 'Section Portal Tapped';
export const PAGINATION_TRANSACTION_LIST_USED = 'Pagination Transaction List Used';
export const CSV_FILE_DOWNLOADED = 'CSV File Downloaded';

const getDateValue = (value: string) => {
    return value ? dayjs(value).format('DD/MM/YYYY') : null;
}

export const initialLogEvent = async (email: string) => {
    const eventProperties = {
      'user_mail': email,
    }
    amplitudeEventTracker.logEvent(PORTAL_OPENED, eventProperties);
}

export const filterLogEvent = (filters: filterProp, removeFilters: boolean, totalResults: number) => {
    const eventProperties = {
        'date': (filters.to && filters.from) ? `${getDateValue(filters.from)} - ${getDateValue(filters.to)}` : null,
        'terminals': filters.terminal_id,
        'status': filters.status,
        'amount': (filters.amount_max && filters.amount_min) ? `${filters.amount_min} - ${filters.amount_max}` : null,
        'delete_filters': removeFilters,
        'total_results': totalResults,
      }
    amplitudeEventTracker.logEvent(FILTER_TRANSACTIONS_PORTAL_TAPPED, eventProperties);
};

export const openDetailEvent = (payment_id: string) => {
    const eventProperties = {
      'payment_id': payment_id,
    }
    amplitudeEventTracker.logEvent(TRANSACTION_DETAIL_TAPPED, eventProperties);
}

export const changeTabEvent = (section: string, oldSection: string) => {
    const eventProperties = {
        'from': oldSection,
        'to': section,
      }
    amplitudeEventTracker.logEvent(SECTION_PORTAL_TAPPED, eventProperties);
}

export const transactionPaginationEvent = (page: number, totalPages: number) => {
    const eventProperties = {
        'pagination': page,
        'total_pages': totalPages,
      }
    amplitudeEventTracker.logEvent(PAGINATION_TRANSACTION_LIST_USED, eventProperties);
}
